export const PlantEphemeral = 'PlantEphemeral'; // однолетник
export const PlantPerennial = 'PlantPerennial'; // многолетник
export const PlantLegume = 'PlantLegume'; // бобовое
export const PlantGrass = 'PlantGrass'; // злак

export const PlantFruits = 'PlantFruits'; // плодовое
export const PlantSucculent = 'PlantSucculent'; // succulent

export const PlantLiana = 'PlantLiana'; // лиана
export const PlantFungus = 'PlantFungus'; // гриб

export const PlantCarnivorous = 'PlantCarnivorous'; // plantCarnivorous
export const PlantParasite = 'PlantParasite'; // паразит